export interface CommentsQuestionModel {
  stop: string;
  start: string;
  continue: string;
}
